import Axios from "../../axios";
import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexLiaisonsStudents(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("/v1/liaisons/students", { params: params });
}
export function indexLiaisonsStudent(
  id: string | number
): Promise<ApiResponse> {
  return Axios.get(`/v1/liaisons/students/${id}`);
}
